import { Map, List } from 'immutable'
import {
  GET_USER_DETAIL_ATTRIBUTIONS,
  SET_USER_DETAIL_ATTRIBUTIONS,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case GET_USER_DETAIL_ATTRIBUTIONS: {
      const { uuid } = payload
      const obj = state.get(uuid, Map())
      const next = obj.set('processing', true)
      return state.set(uuid, next)
    }
    case SET_USER_DETAIL_ATTRIBUTIONS: {
      const { uuid, data, error } = payload
      const obj = state.get(uuid, Map())
      const next = obj.withMutations((o) => o.set('processing', false)
        .set('error', error || false)
        .set('data', data || List()))
      return state.set(uuid, next)
    }
    default:
      return state
  }
}
